import Storage from "@/utils/Storage";

export default {
  token: Storage.getItem("TOKEN") || "",
  userInfo: Storage.getItem("USERINFO") || {},
  uid: Storage.getItem("UID") || "",
  region: Storage.getItem("REGION") || {}, //地区
  company: Storage.getItem("COMPANY") || {}, //公司
  selectactivity: Storage.getItem("SELECTACTIVITY") || {}, //当前选择活动
  cardInfo: {},
  addCurrentProduct: {
    video: "",
    cate_id: "",
    title: "",
    describe: "",
    third_link: "",
    shipping_template_id: null,
    images: [],
    info: [],
    is_live: false,
    sku: [],
    certificates: [],
    source: '',
    send_type: 0,
    is_cross_border: true, // true 跨境销售 false 非跨境销售
    nation:0 ,// 1 国内国外 0 国内 2 国外
    flags: [],
  }, // 暂存的商品
  selectcourse: {}, //当前选择课程
  merchantIndex: {},
  myBankList: [],
  current_router: '',
  path: "",//当前页面路径
  email_list: [],//邮箱
  source_list: Storage.getItem("SOURCELIST") || [],//商品来源
  replay_list: Storage.getItem("REPLAYLIST") || [],//回复评论
  chat_unread_num: Storage.getItem("chat_unread_num") || 0,//未读消息数量
  service_unread_num: Storage.getItem("service_unread_num") || 0,//商家未读消息数量
  show_prompt_sound: true,//消息提示音
  conversation: {},//跳转消息
  prev_delivery: Storage.getItem("prev_delivery") || [],
  AccessKey: Storage.getItem("AccessKey") || {},//上传凭证
};
